import {
  Alert,
  AlertIcon,
  Button,
  CloseButton,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  AlertTitle,
  ModalOverlay,
  Text,
  useToast,
} from "@chakra-ui/react";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useFaqsMaster } from "../../store/faq/reducer";
import { REQUEST_DELETE_MASTER_FAQ } from "../../store/faq/faqActionTypes";
interface Props {
  faq: Record<string, any>;
  isOpen: any;
  onClose: any;
}
const FaqDeleteConfirmation: React.FC<Props> = ({ faq, isOpen, onClose }) => {
  const dispatch = useDispatch();
  const { masterFaqs: faqs, busy, message } = useFaqsMaster();
  const { _id } = faq;
  const toast = useToast();

  useEffect(() => {
    const findFaq = faqs.find((val: Record<string, any>) => val._id === _id);
    if (!findFaq) {
      toast({
        title: "Success.",
        description: "Faq Successfully deleted..",
        status: "success",
        isClosable: true,
        position: "top-right",
      });
      onClose();
    }
  }, [_id, faqs, onClose, toast]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Delete Faq</ModalHeader>
        <ModalCloseButton disabled={busy} />
        <ModalBody>
          <Text fontWeight="bold" mb="1rem">
            Are you sure to delete? {faq.title}
          </Text>
        </ModalBody>
        <ModalFooter>
          <Button variant="outline" mr={3} onClick={onClose} disabled={busy}>
            Close
          </Button>
          <Button
            colorScheme="red"
            variant={"outline"}
            mr={3}
            disabled={busy}
            onClick={() => {
              dispatch({
                type: REQUEST_DELETE_MASTER_FAQ,
                payload: { _id: faq._id },
              });
            }}
          >
            Submit
          </Button>
        </ModalFooter>
        {message && (
          <ModalFooter>
            <Alert status="error">
              <AlertIcon />
              <AlertTitle mr={2}>{message}</AlertTitle>
              <CloseButton position="absolute" right="8px" top="8px" />
            </Alert>
          </ModalFooter>
        )}
      </ModalContent>
    </Modal>
  );
};

export default FaqDeleteConfirmation;
